/**
 * FEATURED IN
 * ----------------------------------------------------------------------------------------------------------------
 * Ported from eternas-theme-impact verbatim. Rotates through the section's quotes every 5 seconds. The logo row
 * never wraps to a second line — instead it measures how many logos actually fit in one row (without wrapping)
 * and only shows that many at a time, sliding the window forward by one logo every time the quote advances. The
 * logo at the front of that window (the one paired with the currently-shown quote) is the highlighted/active one.
 */
(() => {
  const ROTATE_INTERVAL_MS = 5000;

  function init(section) {
    const quotes = Array.from(section.querySelectorAll('[data-featured-in-quote]'));
    const logosContainer = section.querySelector('[data-featured-in-logos]');
    const logos = Array.from(section.querySelectorAll('.featured-in__logo'));

    if (!logosContainer || logos.length === 0) return;

    let index = 0;
    let visibleCount = logos.length;

    function measureVisibleCount() {
      // Show every logo first so their natural widths are measurable.
      logos.forEach((logo) => {
        logo.hidden = false;
      });

      const containerWidth = logosContainer.clientWidth;
      const gap = parseFloat(getComputedStyle(logosContainer).gap) || 0;
      let usedWidth = 0;
      let count = 0;

      for (const logo of logos) {
        const logoWidth = logo.getBoundingClientRect().width;
        const nextWidth = usedWidth + (count > 0 ? gap : 0) + logoWidth;

        if (nextWidth > containerWidth && count > 0) break;

        usedWidth = nextWidth;
        count++;
      }

      visibleCount = Math.max(1, Math.min(count, logos.length));
    }

    function render() {
      logos.forEach((logo, i) => {
        const offsetFromActive = (i - index + logos.length) % logos.length;
        logo.hidden = offsetFromActive >= visibleCount;
        logo.classList.toggle('is-active', i === index);
      });
    }

    function advance() {
      quotes[index] && (quotes[index].hidden = true);
      index = (index + 1) % Math.max(quotes.length, logos.length);
      quotes[index] && (quotes[index].hidden = false);
      render();
    }

    measureVisibleCount();
    render();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        measureVisibleCount();
        render();
      }, 150);
    });

    if (quotes.length > 1 || logos.length > 1) {
      setInterval(advance, ROTATE_INTERVAL_MS);
    }
  }

  document.querySelectorAll('[data-featured-in]').forEach(init);
})();
